import {
  TOTES_INDEX_REQUESTED,
  TOTES_INDEX_SUCCESS,
  TOTES_INDEX_FAILURE,
  TOTES_UNDO_REQUESTED,
  TOTES_UNDO_SUCCESS,
  TOTES_UNDO_FAILURE,
  TOTES_DELETE_REQUESTED,
  TOTES_DELETE_SUCCESS,
  TOTES_DELETE_FAILURE,
  TOTES_ASSIGN_REQUESTED,
  TOTES_ASSIGN_SUCCESS,
  TOTES_ASSIGN_FAILURE,
} from '../types';

const INITIAL_STATE = {
  totes: [],
  isFetching: false,
  isFetchingMore: false,
  lastPage: false,
  continuationToken: null,
  isUndoing: false,
  isDeleting: false,
  isAssigning: false,
  lastActionResult: null,
  status: 'waiting',
  errors: null
};

const mergeTotes = (currentTotes, newTotes) => {
  const mergedTotes = new Map();

  [...currentTotes, ...newTotes].forEach((tote) => {
    mergedTotes.set(tote.sort_key, tote);
  });

  return Array.from(mergedTotes.values());
};

const totes = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case TOTES_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: !action.append,
        isFetchingMore: action.append,
        status: 'requesting',
        errors: null
      });

    case TOTES_INDEX_SUCCESS: {
      const newTotes = action.payload.totes || [];

      return Object.assign({}, state, {
        totes: action.append ? mergeTotes(state.totes, newTotes) : newTotes,
        isFetching: false,
        isFetchingMore: false,
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        status: 'success',
        errors: null
      });
    }

    case TOTES_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchingMore: false,
        status: 'error',
        errors: action.error
      });

    case TOTES_UNDO_REQUESTED:
    case TOTES_DELETE_REQUESTED:
    case TOTES_ASSIGN_REQUESTED:
      return Object.assign({}, state, {
        isUndoing: action.type === TOTES_UNDO_REQUESTED,
        isDeleting: action.type === TOTES_DELETE_REQUESTED,
        isAssigning: action.type === TOTES_ASSIGN_REQUESTED,
        lastActionResult: null,
        status: 'requesting',
        errors: null
      });

    case TOTES_UNDO_SUCCESS:
    case TOTES_DELETE_SUCCESS:
    case TOTES_ASSIGN_SUCCESS:
      return Object.assign({}, state, {
        isUndoing: false,
        isDeleting: false,
        isAssigning: false,
        lastActionResult: action.payload,
        status: 'success',
        errors: null
      });

    case TOTES_UNDO_FAILURE:
    case TOTES_DELETE_FAILURE:
    case TOTES_ASSIGN_FAILURE:
      return Object.assign({}, state, {
        isUndoing: false,
        isDeleting: false,
        isAssigning: false,
        status: 'error',
        errors: action.error
      });

    default:
      return state;
  }
};

export default totes;
